import styled from 'styled-components';
import { Row, Modal, Button } from 'antd';

export const ModalWrapper = styled(Modal)`
	.ant-modal-body {
		padding: 2rem 3rem;
	}

	.ant-modal-content {
		border-radius: 30px;
		background-color: #ffffff;
	}

	.ant-modal-close-x {
		font-size: 0.9rem;
		margin: 0.7rem 0.7rem 0 0;
	}
`;

export const StyledRowCenter = styled(Row)`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const StyledPreviewIcon = styled.div`
	padding: 20px;
	text-align: center;

	.file-icon {
		font-size: 64px;
		color: #070707;
	}
`;

export const PrimaryButton = styled(Button)`
	font-size: 1rem;
	min-width: 7rem;
	min-height: 2.5rem;
	border-radius: 5px;
	background-color: #2f54eb;
	border: 1px solid #2f54eb;
	box-shadow: 0px 2px 0px 0px #0000000b;
`;

export const SecondaryButton = styled(Button)`
	font-size: 1rem;
	min-width: 7rem;
	min-height: 2.5rem;
	border-radius: 5px;
	border: 1px solid #e6e6e6;
	box-shadow: 0px 1px 0px 0px #0000000b;
`;
